import { Component, OnInit, TemplateRef, ViewChild, EventEmitter, ChangeDetectorRef, Output } from '@angular/core';
import { GeneralPreferences } from '../../../shared-components/user-preferences/general-preferences.model';
import { ReportingService } from '../reporting.service';
import { ReportsQueue } from '../models/reports-queue.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../shared-components/shared.service';
import { StudentAttachment } from '../../student-attachment/student-attachment.model';
import { System } from '../../../shared-components/System';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserPreferencesService } from '../../../shared-components/user-preferences/user-preferences.service';
import { UserService } from '../../../shared-components/user/user.service';
import { ReportqueueFilter } from './reportqueue-filter';
import * as moment from 'moment';
import { SpinnerService } from '../../../shared-components/spinner/spinner.service';
// @ts-ignore
import printJS from 'print-js';
import { RouteInfo } from '../../../shared-components/routeInfo';
import { YearService } from '../../../shared-components/year/year.service';
import { Year } from '../../../shared-components/year/year.model';
import * as _ from 'lodash';
import { School } from '../../../shared-components/year/school.model';
import { SecurityService } from '../../../shared-components/security/security.service';

@Component({
  selector: 'app-report-queue',
  templateUrl: './report-queue.component.html',
  styleUrls: ['./report-queue.component.css']
})
export class ReportQueueComponent implements OnInit {
  @ViewChild('filterMenu', { read: TemplateRef }) filterMenu: TemplateRef<any>;

  reportsQueue: ReportsQueue[] = [];
  gridField: ReportsQueue;
  generalPreferences: GeneralPreferences;
  angularMatData = new TylerMatTableDataSource;
  checkedAll: boolean;
  checkIndeterminate: boolean;
  selectedReportQueue: number[] = [];
  columnsToDisplay: string[] = ['CheckBox', 'ReportName', 'SISCode', 'Term', 'UserName', 'RunDate', 'ReportStatus', 'Actions'];
  years: Year[] = [];
  selectedYear: Year;
  schools: School[] = [];
  selectedSchool: School;
  isDataFiltered: boolean;
  studentAttachment = new StudentAttachment();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public gridHeight = 650;
  public gridWidth = 100;
  reportQueqe = false;
  pageSizes = [
    50,
    100,
    250,
    500
  ];
  pageSize = 50;
  isFiltered: boolean = false;
  @Output() clearFilterEvent = new EventEmitter<any>();
  ShowAllUsers: boolean = false;
  ShowCompleted: boolean = false;
  filter = new ReportqueueFilter();
  previousFilter = new ReportqueueFilter();
  showFilter: boolean = false;
  userName: string;
  constructor(
    private userService: UserService,
    private reportService: ReportingService,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<ReportQueueComponent>,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private location: Location,
    private router: Router,
    private userPreferencesService: UserPreferencesService,
    private changeDetector: ChangeDetectorRef,
    private spinnerService: SpinnerService,
    private yearService: YearService,
    private securityService: SecurityService
  ) {
    if (this.location.path() == '/classroom360/reportsQueue') {
      this.reportQueqe = true;
    }
    this.generalPreferences = this.userPreferencesService.generalPreferences;
    this.userName = this.userService.currentUser.UserName.toUpperCase();
    this.years = _.uniqBy(this.yearService.years, 'Id');
    //this.years = this.yearService.years.filter(year => year.SchoolID == this.yearService.defaultYear.SchoolID);
    this.selectedYear = this.years.find(o => o.Id == this.yearService.defaultYear.Id);
    this.schools = this.yearService.schools;
    if (this.schools.filter(o => o.SchoolName == 'All').length == 0) {
      const sch = new School();
      sch.Id = 0;
      sch.SchoolName = 'All';
      this.schools.unshift(sch);
    }
    this.selectedSchool = this.schools.find(o => o.Id == this.yearService.defaultYear.SchoolID);
    const permission = this.securityService.userPermissions.find(o => o.GroupPermissionName == 'SDM Admin Group');
    if (permission != undefined && permission != null) {
      const yr = new Year();
      yr.Id = 0;
      yr.Description = 'All';
      yr.SchoolID = 0;
      this.years.unshift(yr);
    }
  }
  ngOnInit() {
    const dialogRefId: string = this.dialogRef.id != undefined ? this.dialogRef.id.toString() : '';
    if (dialogRefId != '') {
      this.reportQueqe = false;
    }
    if (this.userName == 'SDMADMIN') {
      this.ShowAllUsers = true;
      this.ShowCompleted = true;

    }
    this.filter.Submitted = true;
    this.filter.Running = true;
    this.filter.Completed = true;
    this.filter.ErrorStatus = true;
    this.getReportsQueue(this.ShowAllUsers);
  }
  get initialPageSize(): number {
    if (this.generalPreferences.PageSize != null) {
      return +this.generalPreferences.PageSize;
    }
    else {
      this.pageSize = 50;
    }
  }
  getReportsQueue(ShowAllUsers: boolean) {
    this.reportService.getReportsQueue(ShowAllUsers, this.selectedSchool.Id, this.selectedYear.Id).subscribe(result => {
      if (!this.ShowAllUsers) {
        this.columnsToDisplay.splice(this.columnsToDisplay.indexOf('UserName'), 1);
        if (this.userName != 'SDMADMIN') {
          this.ShowAllUsers = false;
          this.ShowCompleted = false;
        }
      }
      result.forEach(x => x.Selected = false);
      this.reportsQueue = result;
      this.checkedAll = false;
      this.checkIndeterminate = false;
      this.selectedReportQueue = [];
      this.applyFilters();
      setTimeout(() => {
        this.gridHeight = window.innerHeight - 260;
      }, 0);
    });
  }

  checkAll() {
    this.angularMatData.data.forEach(x => x.Selected = this.checkedAll);
    this.getCheckedIds();
  }

  setAllCheckbox() {
    this.checkedAll = false;
    this.checkIndeterminate = false;
    const selectedCount = this.angularMatData.data.filter(x => x.Selected).length;
    if (selectedCount > 0) {
      if (this.angularMatData.data.length === selectedCount) {
        this.checkedAll = true;
      }
      else {
        this.checkIndeterminate = true;
      }
    }
    this.getCheckedIds();
  }

  getCheckedIds() {
    this.selectedReportQueue = [];
    this.reportsQueue.forEach(element => {
      if (element.Selected == true) {
        this.selectedReportQueue.push(element.Id);
      }
    });
  }

  closeClick() {
    if (this.reportQueqe == true) {
      this.dialog.closeAll();
      this.router.navigateByUrl('classroom360/cards');
    } else {
      this.dialogRef.close();
    }
  }

  // reportList() {
  //   this.dialogRef.close();
  // }

  deleteReportQueue(report: ReportsQueue) {

    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Confirm Deletion';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Delete ' + report.ReportName + ' run at ' + (this.datePipe.transform(report.RunDate, 'MM/dd/yy h:mm a'));
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject && report.Id > 0) {
        const reportIds: number[] = [];
        reportIds.push(report.Id);
        this.reportService.deleteReportsQueue(reportIds).subscribe(result => {
          this.getReportsQueue(this.ShowAllUsers);
        });
      }
    });
  }

  deleteSelected() {
    if (this.selectedReportQueue.length > 0) {
      this.reportService.deleteReportsQueue(this.selectedReportQueue).subscribe(result => {
        this.getReportsQueue(this.ShowAllUsers);
      });
    }
  }
  refreshPage() {
    this.getReportsQueue(this.ShowAllUsers);
  }
  saveFile(report: ReportsQueue) {
    const studentAttachment: StudentAttachment = {
      DocumentId: report.Id,
      DocumentName: report.ReportName,
      DocumentBase64: '',
      DocumentMimeType: '',
      DocumentModuleName: 'ReportQueue',
      ReportParameters: [],
      ReportType: 0
    };
    window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
    window.open(System.baseUrl + 'studentattachment', '_blank');
  }
  clearFilter() {
    // Clearing the filter
    this.filter = new ReportqueueFilter();
    if (this.userName == 'SDMADMIN') {
      this.ShowCompleted = true;
    }
    this.filter.Submitted = true;
    this.filter.Running = true;
    this.filter.Completed = true;
    this.filter.ErrorStatus = true;
    this.previousFilter = new ReportqueueFilter();
    this.clearFilterEvent.emit();
    this.angularMatData.removeAllFilters();
    this.applyFilter();
  }
  formChanged() {
    if (!this.ShowCompleted) {
      this.filter.Submitted = true;
      this.filter.Running = true;
      this.filter.ErrorStatus = true;
      this.filter.Completed = false;
    }
    else if (this.ShowCompleted) {
      this.filter.Submitted = true;
      this.filter.Running = true;
      this.filter.ErrorStatus = true;
      this.filter.Completed = true;
    }
    this.applyFilters();
  }
  applyFilters() {
    this.columnsToDisplay = [];
    let tableData: ReportsQueue[] = [];
    this.columnsToDisplay = ['CheckBox', 'ReportName', 'SISCode', 'Term', 'UserName', 'RunDate', 'ReportStatus', 'Actions'];
    // Set the table data after finishing filtering
    if (this.isPanelPreviousFiltered() == true) {
      Object.assign(this.filter, this.previousFilter);

      if (this.ShowCompleted && this.showFilter) {
        this.filter.Submitted = true;
        this.filter.Running = true;
        this.filter.ErrorStatus = true;
        this.filter.Completed = this.ShowCompleted;
      }
    }
    else if (this.userName != 'SDMADMIN') {
      this.filter.Submitted = true;
      this.filter.Running = true;
      this.filter.Completed = true;
      this.filter.ErrorStatus = true;
    }
    if (!this.ShowAllUsers) {
      this.columnsToDisplay.splice(this.columnsToDisplay.indexOf('UserName'), 1);
    }

    if (this.ShowCompleted && this.ShowAllUsers) {
      tableData = this.reportsQueue;
    }
    else if (!this.ShowCompleted && this.ShowAllUsers) {
      tableData = this.reportsQueue.filter(r => r.ReportStatus != 'Completed');
    }
    else if (!this.ShowCompleted && !this.ShowAllUsers && this.userName == 'SDMADMIN') {
      tableData = this.reportsQueue.filter(r => r.ReportStatus != 'Completed' && (r.UserName).toUpperCase() == this.userName);
    }
    else if (!this.ShowAllUsers) {
      tableData = this.reportsQueue.filter(r => (r.UserName).toUpperCase() == this.userName);
    }
    if (this.showFilter) {

      tableData = tableData.filter(be => (be.ReportStatus == 'Submitted' && this.filter.Submitted) ||
        (be.ReportStatus == 'Completed' && this.filter.Completed) ||
        (be.ReportStatus == 'Running' && this.filter.Running) ||
        (be.ReportStatus == 'Error' && this.filter.ErrorStatus)
      );
      if (this.filter.ReportName) {
        const fromDate = this.filter.startDate;
        tableData = tableData.filter(be => be.ReportName.toLowerCase().includes(this.filter.ReportName.toLowerCase()));
      }
      if (this.filter.SISCode) {
        const fromDate = this.filter.startDate;
        tableData = tableData.filter(be => be.SISCode.toLowerCase().includes(this.filter.SISCode.toLowerCase()));
      }
      if (this.filter.UserName && this.ShowAllUsers) {
        const fromDate = this.filter.startDate;
        tableData = tableData.filter(be => be.UserName.toLowerCase().includes(this.filter.UserName.toLowerCase()));
      }

      if (this.filter.startDate && this.filter.startDate.toString() != 'Invalid Date') {
        const fromDate = this.filter.startDate;
        tableData = tableData.filter(be => moment(moment(be.RunDate, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY'), 'MM/DD/YY').isSameOrAfter(fromDate));
      }
      if (this.filter.endDate && this.filter.endDate.toString() != 'Invalid Date') {
        tableData = tableData.filter(be => moment(moment(be.RunDate, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY'), 'MM/DD/YY').isSameOrBefore(this.filter.endDate));
      }
    }
    if (this.isPanelPreviousFiltered() == true) {
      this.applyFilter();
    }
    else {

      this.angularMatData = new TylerMatTableDataSource(tableData);
      this.angularMatData.data = tableData;
      this.angularMatData.sort = this.sort;
      this.angularMatData.paginator = this.paginator;
      this.isFiltered = false;
      if ((!!this.filter.startDate || !!this.filter.endDate || !!this.filter.ReportName
        || !!this.filter.SISCode || !!this.filter.UserName) ||
        (!this.filter.Completed || !this.filter.Submitted || !this.filter.Running || !this.filter.ErrorStatus)) {
        this.isFiltered = true;
      }

    }
  }

  openFilter() {
    this.showFilter = true;
    this.gridWidth = this.showFilter ? 84 : 100;
    if (this.userName == 'SDMADMIN' && this.ShowCompleted) {
      this.filter.Submitted = true;
      this.filter.Completed = true;
      this.filter.Running = true;
      this.filter.ErrorStatus = true;
    }
    this.applyFilters();
  }

  // Methods
  applyFilter() {
    // POST: applies the filter
    // Dates
    let tableData: ReportsQueue[] = [];
    tableData = this.reportsQueue;
    if (this.userName == 'SDMADMIN' && (!this.filter.Completed || !this.filter.Submitted || !this.filter.Running || !this.filter.ErrorStatus)) {
      this.ShowCompleted = false;
    }
    else if (this.userName == 'SDMADMIN' && this.filter.Completed && (this.filter.Submitted && this.filter.Running && this.filter.ErrorStatus)) {
      this.ShowCompleted = this.filter.Completed;
    }
    tableData = tableData.filter(be => (be.ReportStatus == 'Submitted' && this.filter.Submitted) ||
      (be.ReportStatus == 'Completed' && this.filter.Completed) ||
      (be.ReportStatus == 'Running' && this.filter.Running) ||
      (be.ReportStatus == 'Error' && this.filter.ErrorStatus)
    );
    if (this.filter.ReportName) {
      const fromDate = this.filter.startDate;
      tableData = tableData.filter(be => be.ReportName.toLowerCase().includes(this.filter.ReportName.toLowerCase()));
    }
    if (this.filter.SISCode) {
      const fromDate = this.filter.startDate;
      tableData = tableData.filter(be => be.SISCode.toLowerCase().includes(this.filter.SISCode.toLowerCase()));
    }
    if (this.filter.UserName && this.ShowAllUsers) {
      const fromDate = this.filter.startDate;
      tableData = tableData.filter(be => be.UserName.toLowerCase().includes(this.filter.UserName.toLowerCase()));
    }

    if (this.filter.startDate && this.filter.startDate.toString() != 'Invalid Date') {
      const fromDate = this.filter.startDate;
      tableData = tableData.filter(be => moment(moment(be.RunDate, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY'), 'MM/DD/YY').isSameOrAfter(fromDate));
    }
    if (this.filter.endDate && this.filter.endDate.toString() != 'Invalid Date') {
      tableData = tableData.filter(be => moment(moment(be.RunDate, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY'), 'MM/DD/YY').isSameOrBefore(this.filter.endDate));
    }

    this.angularMatData = new TylerMatTableDataSource(tableData);
    this.angularMatData.data = tableData;
    this.angularMatData.sort = this.sort;
    this.angularMatData.paginator = this.paginator;
    this.isFiltered = false;
    if ((!!this.filter.startDate || !!this.filter.endDate || !!this.filter.ReportName
      || !!this.filter.SISCode || !!this.filter.UserName) ||
      (!this.filter.Completed || !this.filter.Submitted || !this.filter.Running || !this.filter.ErrorStatus)) {
      this.isFiltered = true;
    }
  }

  saveFilter() {
    // PRE: the save button is clicked in the filter
    // POST: saves the filter and closes the menu
    this.showFilter = false;
    this.gridWidth = this.showFilter ? 84 : 100;
    setTimeout(
      () => {
        // Saving the filter to the previous filter
        this.previousFilter = new ReportqueueFilter();
        Object.assign(this.previousFilter, this.filter);
        // Applying the filter
        this.applyFilters();
        // Detecting changes to prevent errors
        this.changeDetector.detectChanges();
      },
      0
    );
  }

  closeFilter() {
    this.showFilter = false;
    this.gridWidth = this.showFilter ? 84 : 100;
    // PRE: the close filter button is clicked
    // POST: reverts the filter and closes the menu
    setTimeout(
      () => {
        // Resetting the filter
        if (this.isPanelPreviousFiltered() == false) {
          this.initialFilter();
        }
        // Applying the filter
        this.applyFilters();
        // Detecting page changes to deal with ExpressionChanged errors
        this.changeDetector.detectChanges();
      },
      0
    );
  }
  isPanelFiltered(): boolean {
    return !!this.filter.startDate ||
      !!this.filter.endDate ||
      !!this.filter.ReportName ||
      !!this.filter.SISCode ||
      !!this.filter.UserName ||
      this.filter.Completed ||
      this.filter.Submitted ||
      this.filter.Running ||
      this.filter.ErrorStatus;
  }
  isPanelPreviousFiltered(): boolean {
    return !!this.previousFilter.startDate ||
      !!this.previousFilter.endDate ||
      !!this.previousFilter.ReportName ||
      !!this.previousFilter.SISCode ||
      !!this.previousFilter.UserName ||
      this.previousFilter.Completed ||
      this.previousFilter.Submitted ||
      this.previousFilter.Running ||
      this.previousFilter.ErrorStatus;
  }
  initialFilter() {
    this.filter = new ReportqueueFilter();
    if (this.userName == 'SDMADMIN') {
      this.ShowAllUsers = true;
      this.ShowCompleted = true;
    }
    this.filter.Submitted = true;
    this.filter.Running = true;
    this.filter.Completed = true;
    this.filter.ErrorStatus = true;
  }
  printClick() {
    if (this.router.url.indexOf('classroom360/reportsQueue') > 0) {
      // Timeout is needed to allow the spinner to show before the print preview load takes priority
      setTimeout(() => {
        this.sharedService.pageToPdfTrigger = !this.sharedService.pageToPdfTrigger;
      }, 0);
    }
    else {
      // If page open from  matDialog should use Id
      const dialogRefId: string = this.dialogRef.id != undefined ? this.dialogRef.id.toString() : '';
      const pagePrintStyle: string = RouteInfo.getPagePrintStyle(this.router.url);
      const styleURLs: string[] = ['./assets/styles/print-styles.css'];

      if (pagePrintStyle) {
        styleURLs.push(pagePrintStyle);
      }
      this.spinnerService.showSpinner = true;
      // Timeout is needed to allow the spinner to show before the print preview load takes priority
      setTimeout(() => {
        printJS({
          printable: this.router.url.toString() == '/classroom360/reportsQueue' ? 'print-content' : dialogRefId,
          documentTitle: 'OneSIS',
          type: 'html',
          css: styleURLs,
          ignoreElements: ['print-ignore'],
          targetStyles: ['*'],
          maxWidth: 1500
        });
        this.spinnerService.showSpinner = false;
      }, 500);
    }
  }

  yearChange() {
    this.yearService.getUserSchools(this.selectedYear.Id).subscribe(results => {
      this.schools = results;
      if (this.schools.filter(o => o.SchoolName == 'All').length == 0) {
        const sch = new School();
        sch.Id = 0;
        sch.SchoolName = 'All';
        this.schools.unshift(sch);
      }
      const selectedSchool: School = this.schools.find(o => o.Id == this.selectedSchool.Id) != undefined ? this.schools.find(o => o.Id == this.selectedSchool.Id) : this.schools.find(o => o.Id == this.selectedYear.SchoolID);
      this.selectedSchool = selectedSchool;
    });
  }

  schoolChange() { }

  searchClick() {
    this.getReportsQueue(this.ShowAllUsers);
  }
}
